import type { API } from 'chessboard/api/config/types';
import { Board } from 'chessboard/model/board/types';
import type { Core } from 'chessboard/core/config/types';
import { createKeyedHighlight } from 'chessboard/plugins/highlights/model/create-keyed-highlight';
import type { KeyedHighlight } from 'chessboard/plugins/highlights/config/types';
import { getLegacyThemeValues } from 'chessboard/config/legacy-themes';
import { nodeTargetSquare } from 'api/move/model/node-target-square';

export const MoveHighlight = 'move';

/**
 * Gets an array of move highlights for the last move.
 */
export function getMoveHighlights(_event: Core.Event, context: Core.Context): KeyedHighlight[] {
  const { api, options }: { api: API.Model; options: Board.Options } = context;

  const highlights: KeyedHighlight[] = [];

  if (!options || !options.highlightMoves) {
    return highlights;
  }

  const node = api.getSelectedNode();

  if (!node) {
    return highlights;
  }

  [node.from, nodeTargetSquare(node)].forEach((square) => {
    if (!square) {
      return;
    }

    const highlight = createKeyedHighlight({
      color:
        options.themeAssets?.board.config.highlightSquareHex ??
        options.highlightColor ??
        getLegacyThemeValues(options.boardStyle)?.highlightColor ??
        Board.HighlightColors.Selected,
      opacity: options.highlightOpacity,
      square,
      turn: node.color,
      type: MoveHighlight,
    });

    highlights.push(highlight);
  });

  return highlights;
}
